import { TYPES } from "./role.type";

const initState = {
  owner: null,
  isOwner: false,
};

const ownerReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_OWNER_INFO_SUCCESS:
      return {
        ...state,
        owner: payload,
      };
    case TYPES.SELECT_IS_OWNER_SUCCESS:
      return {
        ...state,
        isOwner: payload,
      };
    default:
      return state;
  }
};

export default ownerReducer;
